export type TeamHierarchySection =
  | 'agents'
  | 'knowledge'
  | 'users'
  | 'scheduled-tasks'
  | 'model-providers'
  | 'metrics'
  | 'work'
  | 'billing'
  | 'files'
  | 'workspaces'
  | 'skills-policy'
  | 'network-policy'
  | 'sso'
  | 'settings'
  | 'secrets'
  | 'roles'
  | 'chat'
  | 'projects';

export type AgentHierarchySection =
  | 'metrics'
  | 'skills'
  | 'knowledge'
  | 'memories'
  | 'work'
  | 'communications'
  | 'activities'
  | 'testing'
  | 'tools'
  | 'secrets'
  | 'channels'
  | 'scheduled-tasks'
  | 'workspaces'
  | 'model'
  | 'settings';

export function teamSwitchTarget(
  teamId: number,
  context:
    | { scope: 'child' }
    | { scope: 'team'; section: TeamHierarchySection | null },
): string {
  if (context.scope === 'team' && context.section) {
    return `/console/team/${teamId}/${context.section}`;
  }

  return `/console/team/${teamId}`;
}

export function projectSwitchTarget(teamId: number, projectId: number): string {
  return `/console/team/${teamId}/projects/${projectId}`;
}

export function agentSwitchTarget(
  teamId: number,
  agentId: number,
  section: AgentHierarchySection | null,
): string {
  const agentHome = `/console/team/${teamId}/agent/${agentId}`;
  return section ? `${agentHome}/${section}` : agentHome;
}
